import { Fragment } from 'react';
import { Field, Form, Formik } from 'formik';
import Segment from '../shared/segment';
import Divider from '../shared/divider';
import Alert from '../shared/alert';
import Button from '../shared/buttons/button';
import FormInput from '../shared/forms/input';
import { mobile, required } from '../shared/forms/validations';
import { useFormErrorMessage } from '../../hooks/index/use-form-error-message';
import { APIErrorType } from '../../api';

export type MobileFormPropsType = {
  onSubmit: (mobile: string) => Promise<void>;
};

function MobileForm(props: MobileFormPropsType) {
  const { formErrorMessage, setFormError, resetFormErrorMessage } = useFormErrorMessage();

  async function submit({ mobile }: { mobile: string }) {
    try {
      await props.onSubmit(mobile);
    } catch (error) {
      setFormError(error as APIErrorType);
    }
  }

  return (
    <Segment>
      <Divider content='فرم فراموشی رمز عبور' />
      <Formik initialValues={{ mobile: '' }} onSubmit={submit}>
        {({ dirty, isSubmitting }) => (
          <Fragment>
            {dirty && formErrorMessage && (
              <Alert content={formErrorMessage} className='mt-3 mb-5' />
            )}

            <Form onChange={resetFormErrorMessage}>
              <Field
                required
                name='mobile'
                label='شماره تلفن همراه'
                placeholder='09121234567'
                component={FormInput}
                type='tel'
                maxLength={11}
                validate={mobile}
              />
              <div className='text-medium my-4'>
                شماره تلفن همراه وارد شده هنگام ثبت نام را وارد کنید.
              </div>
              <Button
                type='submit'
                disabled={!dirty || isSubmitting}
                content='ادامه'
                className='my-2 mr-auto'
              />
            </Form>
          </Fragment>
        )}
      </Formik>
    </Segment>
  );
}

export default MobileForm;
